(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-correction.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-correction.js');

'use strict';

const {
  useEffect
} = React;
const {
  getCorrectionMapHandler
} = svs.lyckoplatsen.components.shared_map;
const {
  useAtomValue,
  useAtom
} = jotai;
const {
  wagersAtom
} = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms;
const {
  selectedResultAtom,
  playCorrectionTlAtom,
  correctionStepAtom,
  correctionTriggerTypeAtom,
  autoPlayLatestCorrectionTlAtom,
  distributionArrayAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const {
  CONSTANTS: {
    CORRECTION_STEP,
    CORRECTION_TRIGGER_TYPE
  }
} = svs.lyckoplatsen.components.shared_constants;
const {
  mapErrorDialogNoRedirect
} = svs.lyckoplatsen.shared_map.utils;
const mapHandlerCorrection = getCorrectionMapHandler();
const MapCorrection = () => {
  const mapId = 'map-correction';
  const wagers = useAtomValue(wagersAtom);
  const result = useAtomValue(selectedResultAtom);
  const distributionArray = useAtomValue(distributionArrayAtom);
  const [correctionTriggerType, setCorrectionTriggerType] = useAtom(correctionTriggerTypeAtom);
  const [play, setPlay] = useAtom(playCorrectionTlAtom);
  const [autoPlayLatest, setAutoPlayLatest] = useAtom(autoPlayLatestCorrectionTlAtom);
  const [correctionStep, setCorrectionStep] = useAtom(correctionStepAtom);
  const [showMapErrorDialog, setShowMapErrorDialog] = React.useState(false);
  const mapErrorDialog = React.useCallback(() => {
    const step = productMapping.isLyckoplatsenPrimary(result.productId) ? 1 : 2;
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      icon: 'exclamation-sign',
      title: 'Karttjänsten ur funktion',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        align: svs.ui.dialog.message.align.CENTER,
        text: "Just nu g\xE5r det inte att visa kartan. Du kan visa r\xE4ttningen utan karta. Vill du se kartan f\xF6rs\xF6k igen om en stund"
      }],
      actions: [{
        title: 'Avbryt',
        callback(e, form, dialog) {
          dialog.close();
          setShowMapErrorDialog(false);
          if (correctionStep === CORRECTION_STEP.TOPWIN) {
            mapHandlerCorrection.tlSeek(1);
          }
          if (correctionStep >= CORRECTION_STEP.PLACE) {
            setCorrectionStep(step);
          }
        }
      }, {
        title: 'Fortsätt',
        callback(_e, _form, dialog) {
          dialog.close();
          setShowMapErrorDialog(false);
          setTimeout(() => {
            if (correctionStep <= CORRECTION_STEP.PLACE) {
              setPlay(true);
            } else {
              mapHandlerCorrection.tlPlay();
            }
          }, 1000);
        }
      }]
    }));
  }, [correctionStep, result.productId, setCorrectionStep, setPlay]);
  useEffect(() => {
    const mapOptions = {
      nodeId: mapId,
      dragging: false,
      zoom: 15,
      zoomSnap: 0.2,
      zoomControl: false,
      scrollWheelZoom: false,
      geoJsonInv: false,
      showErrorOverlay: false,
      distributionArray,
      errorCallback: mapErrorDialogNoRedirect
    };
    const eventHandlers = {
      automatedStepUpdate: index => {
        setCorrectionTriggerType(CORRECTION_TRIGGER_TYPE.AUTOMATED);
        setCorrectionStep(index);
      },
      play: bool => {
        setPlay(bool);
      },
      showMapErrorDialog: () => setShowMapErrorDialog(true)
    };
    mapHandlerCorrection.createMap(mapOptions, result, wagers, eventHandlers);
    return () => {
      mapHandlerCorrection.removeMap();
      mapHandlerCorrection.tlKill();
      setPlay(false);
      setAutoPlayLatest(false);
    };
  }, [mapHandlerCorrection, mapId, result, setAutoPlayLatest, setCorrectionStep, setCorrectionTriggerType, setPlay]);

  useEffect(() => {
    if (showMapErrorDialog && play) {
      if (correctionStep <= CORRECTION_STEP.PLACE) {
        setPlay(false);
      } else {
        !play && mapHandlerCorrection.tlPause();
      }
      mapErrorDialog();
    }
  }, [showMapErrorDialog, play, setPlay, mapErrorDialog, correctionStep]);

  useEffect(() => {
    if (play) {
      mapHandlerCorrection.tlPlay();
    } else {
      mapHandlerCorrection.tlPause();
    }
  }, [play]);

  useEffect(() => {
    if (correctionTriggerType === CORRECTION_TRIGGER_TYPE.CLICK) {
      if (correctionStep >= CORRECTION_STEP.TOPWIN && correctionStep <= CORRECTION_STEP.DISTANCE) {
        mapHandlerCorrection.tlSeek(correctionStep);
      }
      setAutoPlayLatest(false);
    }
    if (correctionStep === CORRECTION_STEP.TOPWIN || correctionStep === CORRECTION_STEP.PLACE && productMapping.isLyckoplatsenSecondary(result.productId)) {
      setPlay(false);
    }
    if (correctionStep === CORRECTION_STEP.PLACE && productMapping.isLyckoplatsenPrimary(result.productId) || correctionStep === CORRECTION_STEP.DISTANCE) {
      setPlay(true);
      setAutoPlayLatest(false);
    }
    if (autoPlayLatest) {
      setPlay(true);
    }
  }, [correctionStep, setPlay, result.productId, correctionTriggerType, autoPlayLatest, setAutoPlayLatest]);
  return React.createElement("div", {
    id: mapId,
    className: "lp-map-correction"
  });
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  MapCorrection
});

 })(window);